import { Link } from "react-router-dom";

interface VideoCardProps {
  id: string;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  quality: string;
  views: string;
  rating: number;
  tags: string[];
  isHot?: boolean;
  isNew?: boolean;
  updateInfo: string;
}

export default function VideoCard({
  id,
  title,
  category,
  thumbnail,
  duration,
  quality,
  views,
  rating,
  tags,
  isHot,
  isNew,
  updateInfo,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div className="relative aspect-video rounded-lg overflow-hidden bg-background-100 mb-3">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-red-500 text-white">
              热门
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-accent-500 text-white">
              新上
            </span>
          )}
          <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-foreground-950/70 text-white">
            {quality}
          </span>
        </div>
        <div className="absolute bottom-2 right-2">
          <span className="px-2 py-0.5 rounded-md text-[10px] font-medium bg-foreground-950/70 text-white">
            {duration}
          </span>
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center">
            <i className="ri-play-fill text-foreground-950 text-xl ml-0.5"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-950 leading-snug group-hover:text-primary-500 transition-colors line-clamp-2 mb-1.5">
        {title}
      </h3>

      <div className="flex items-center gap-2 text-xs text-foreground-500 mb-1.5 flex-wrap">
        <span className="flex items-center gap-0.5">
          <i className="ri-star-fill text-amber-400 text-xs"></i>
          {rating}
        </span>
        <span className="text-foreground-300">|</span>
        <span>{views}次播放</span>
      </div>

      <div className="flex items-center gap-1.5 flex-wrap">
        {tags.slice(0, 2).map((tag) => (
          <span
            key={tag}
            className="px-2 py-0.5 rounded-full text-[10px] bg-secondary-100 text-secondary-700"
          >
            {tag}
          </span>
        ))}
        <span className="text-[10px] text-foreground-400">{updateInfo}</span>
      </div>
    </Link>
  );
}